export enum LocalStorageEnum {
  PHONENUMBER = "phoneNumber",
  TOKEN = "token",
}
